var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { IconWrapper } from ".";
export const BrandPlaceholderIcon = React.forwardRef((_a, ref) => {
    var { color = "primary" } = _a, otherProps = __rest(_a, ["color"]);
    return (React.createElement(IconWrapper, Object.assign({ ref: ref, width: 24, height: 24, color: color }, otherProps),
        React.createElement("g", { "clip-path": "url(#clip0)" },
            React.createElement("circle", { cx: "48", cy: "48", r: "48", fill: "#C4CBD4" })),
        React.createElement("path", { d: "M29 38C29 39.1 29.9 40 31 40C32.1 40 33 39.1 33 38V34H37C38.1 34 39 33.1 39 32C39 30.9 38.1 30 37 30H33V26C33 24.9 32.1 24 31 24C29.9 24 29 24.9 29 26V30H25C23.9 30 23 30.9 23 32C23 33.1 23.9 34 25 34H29V38Z", fill: "white" }),
        React.createElement("path", { d: "M49 56C52.3137 56 55 53.3137 55 50C55 46.6863 52.3137 44 49 44C45.6863 44 43 46.6863 43 50C43 53.3137 45.6863 56 49 56Z", fill: "white" }),
        React.createElement("path", { d: "M65 34H58.66L56.18 31.3C55.44 30.48 54.36 30 53.24 30H40.44C40.78 30.6 41 31.26 41 32C41 34.2 39.2 36 37 36H35V38C35 40.2 33.2 42 31 42C30.26 42 29.6 41.78 29 41.44V62C29 64.2 30.8 66 33 66H65C67.2 66 69 64.2 69 62V38C69 35.8 67.2 34 65 34ZM49 60C43.48 60 39 55.52 39 50C39 44.48 43.48 40 49 40C54.52 40 59 44.48 59 50C59 55.52 54.52 60 49 60Z", fill: "white" }),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0" },
                React.createElement("rect", { width: "96", height: "96", fill: "white" })))));
});
//# sourceMappingURL=BrandPlaceholder.js.map